/** Base path shared by every svc-lux-loyalty service client in this directory. */
export const BASE_PATH = `${window.configs.API_HOST}/api/lux-loyalty`;
